import React from "react";

import styles from "./tab.module.css";

interface TabOption<T> {
  label: string;
  value: T;
}

interface TabsProps<T> {
  value: T;
  onChange: (value: T) => void;
  options: TabOption<T>[];
}

export function Tabs<T>({ options, value, onChange }: TabsProps<T>) {
  return (
    <div className={styles.container}>
      {options.map((option) => (
        <Tab
          key={option.label}
          onSelect={onChange}
          option={option}
          active={option.value === value}
        />
      ))}
    </div>
  );
}

interface TabProps<T> {
  active: boolean;
  option: TabOption<T>;
  onSelect: (value: T) => void;
}

function Tab<T>({ active, option, onSelect }: TabProps<T>) {
  return (
    <button
      className={`${styles.tab}  ${active ? styles.active : styles.default}`}
      onClick={() => onSelect(option.value)}
    >
      {option.label}
    </button>
  );
}
